import Reveal from '../animation/Reveal';
import { services } from '../../data/siteContent';
import ServiceCard from './ServiceCard';

function ServicePreview() {
  return (
    <Reveal as="section" className="section service-band">
      <Reveal className="section-heading" delay={0.05}>
        <p className="section-label">Services</p>
        <h2>Tailoring support for daily wear, formal looks, and business teams.</h2>
      </Reveal>
      <div className="service-grid">
        {services.map((service, index) => (
          <ServiceCard key={service.title} service={service} delay={index * 0.08} />
        ))}
      </div>
    </Reveal>
  );
}

export default ServicePreview;
